import CustomerCartListPage from "../../../features/admin/customer-cart-list/customer-cart-list-page";

export default function CustomerCartList() {
  return <CustomerCartListPage />;
}
